import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';

export const OTHERS_SIDEBAR_SECTION: ISidebarSection = {
    id: 'surveillance',
    title: 'Ações Gerais',
    items: [
        {
            id: 'shifts',
            title: 'Turnos',
            route: '/turno',
            icon: 'briefcase',
            isVisible: true,
        },
        {
            id: 'reports',
            title: 'Relatórios',
            icon: 'report',
            children: [
                {
                    id: 'occurrence-report',
                    title: 'Relatório de Ocorrência',
                    route: '/relatorio-ocorrencia',
                    isVisible: true,
                },
                {
                    id: 'occurrence-dispatch',
                    title: 'Despacho de Ocorrência',
                    route: '/despacho-ocorrencia',
                    isVisible: true,
                },
                {
                    id: 'send-doc-admin',
                    title: 'Enviar Documento',
                    route: '/enviar-documento',
                    isVisible: true,
                },
            ],
            isVisible: true,
        },
    ],
    isVisible: true,
};

export const OTHERS_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'OTHERS',
    sections: [BASE_SIDEBAR_SECTION, OTHERS_SIDEBAR_SECTION],
};
